import script from "./NbsIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./NbsIcon.vue?vue&type=script&setup=true&lang=js"

import "./NbsIcon.vue?vue&type=style&index=0&id=827f7c14&lang=scss"

const __exports__ = script;

export default __exports__